<script lang="ts">
    import EmployeeWidget from "$lib/partials/EmployeeWidget.svelte";
    import EmployeeFormGroup from "$lib/partials/EmployeeFormGroup.svelte";
    import {getCostCenters} from "$lib/calls/unit";
    import {onMount} from "svelte";
    import dayjs from "dayjs";
    import {availableQualifications} from "$lib/calls/qualification";
    import {Button, Input, Label, Modal} from "flowbite-svelte";
    import {extendContract} from "$lib/calls/employee";
    import ContractStatusCard from "$lib/partials/employee/ContractStatusCard.svelte";
    import {asValue} from "$lib/utils/lenkradDate.js";
    import type {Employee} from "$lib/types/employee";
    import InfoBox from "$items/InfoBox.svelte";

    export let employee: Employee;

    let editing = false;
    let masterCostCenterOptions = [];
    let qualifications = [];
    let prolongingModal = false;

    let payGroupOptions = [
        {value:1, name:1},
        {value:2, name: 2},
    ]

    let contractStati = {
        'signed': 'Unterschrieben',
        'planned': 'Geplant',
        'waiting_for_employee_signature': 'Erwarte Signatur des Mitarbeiters',
        'waiting_for_hr_signature': 'Erwarte Signatur von HR',
        'synchronized': 'Arbeitsvertrag',
    }

    let prolongingContract = {};

    const openProlongingModal = contract => {
        prolongingContract = contract;
        prolongingContract.newEndDate = dayjs(prolongingContract.endDate).add(1, 'year').format('YYYY-MM-DD');
        prolongingModal = true;
    }
    const prolongContract = async () => {

        try{
            const result = await extendContract(employee.uuid, prolongingContract);
            employee.contracts = [...employee.contracts, result];
        } catch (e) {

        }
        prolongingModal = false;

    }

    onMount(async () => {
        masterCostCenterOptions = await getCostCenters();
        qualifications = await availableQualifications();
    })
</script>
<Modal bind:open={prolongingModal} title="Vertrag verlängen">
    <p>
        Vertrag unter <strong>{masterCostCenterOptions.find(option => option.id === prolongingContract.costCenterId)?.name}</strong>,
        gültig bis <strong>{dayjs(asValue(prolongingContract.endDate)).format('DD.MM.YYYY')}</strong>, <br>verlängern?
    </p>
    <Label class="space-y-2">
        <span>Neues Enddatum</span>
        <Input min="{dayjs(asValue(prolongingContract.endDate)).add(2, 'day').format('YYYY-MM-DD')}" type="date" bind:value={prolongingContract.newEndDate}/>
    </Label>
    <svelte:fragment slot="footer">
        <div class="flex gap-3 justify-between w-full">
            <Button color="red" on:click={() => prolongingModal = false}>Abbrechen</Button>
            <Button on:click={prolongContract}>Ja, verlängern</Button>
        </div>
    </svelte:fragment>
</Modal>
{#each employee?.contracts.sort((a, b) => dayjs(asValue(b.endDate)).valueOf() - dayjs(asValue(a.endDate)).valueOf()) || [] as contract, i}
    <div class="mb-5">
        <EmployeeWidget headline={contractStati[contract.employmentContractStatus] + ' - ' + contract.contractType} collapsible open={i<1}>
            <div class="text-sm" slot="cta">
                <div>
                    {dayjs(asValue(contract.startDate)).format('DD.MM.YYYY') || ''} - {dayjs(asValue(contract.endDate)).format('DD.MM.YYYY') || ''}
                    {#if contract.endDate && contract.prolongedCounter < 3 && contract.contractType !== 'prolonging' && contract.employmentContractStatus === 'synchronized'}
                        <Button on:click={() => openProlongingModal(contract)} color="yellow" size="xs" class="ml-2">Verlängern {contract.employmentContractStatus}</Button>
                    {/if}
                </div>

            </div>
            <svelte:fragment slot="header">
                <ContractStatusCard bind:employee={employee} bind:contract={contract}/>
            </svelte:fragment>
            <svelte:fragment slot="left">


                <InfoBox
                        title="Stammkostenstelle"
                        items={masterCostCenterOptions}
                        value={contract.costCenterId}
                        type="select">
                </InfoBox>
                {masterCostCenterOptions.find(option => option.id === contract.costCenterId || '')?.name || '-'}

                <EmployeeFormGroup
                        {editing}
                        label="Beginn der Tätigkeit"
                        labelFor="employmentStartedAt"
                        type="date">
                    {dayjs(asValue(contract.startDate)).format('DD.MM.YYYY') || ''}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Ende der Tätigkeit"
                        labelFor="employmentEndedAt"
                        type="date">
                    {contract.endDate ? dayjs(asValue(contract.endDate)).format('DD.MM.YYYY') : '-'}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Entgeltgruppe"
                        labelFor="payGroup"
                        data={payGroupOptions}
                        extract={selected => employee.payGroupId = selected.value}>
                    {qualifications.find(x => x.id === contract.qualificationId)?.payGroup || '-'}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Stundenlohn"
                        labelFor="hourlyRate"
                        suffix="€">
                    {contract.wagePerHour || ''} €
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Aktueller Status"
                        labelFor="status"
                        extract={selected => employee.statusId = selected.value}>
                    {employee.status || ''}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Arbeitsvertrag"
                        labelFor="employmentContract"
                        extract={selected => employee.employmentContractId = selected.value}>
                    {contract.contractType}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Probezeit"
                        labelFor="monthOfProbationaryPeriod"
                        suffix="Monate">
                    {contract.trialPeriodMonths || 0} Monate
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Gruppe"
                        labelFor="group"
                        extract={selected => employee.groupId = selected.value}>
                    {contract.group}
                </EmployeeFormGroup>
                <!--
                            <EmployeeFormGroup
                                    {editing}
                                    label="AÜN"
                                    labelFor="employeeLeasing"
                                    data={employeeLeasingOptions}
                                    extract={selected => employee.employeeLeasingId = selected.value}>
                                {employeeLeasingOptions.find(option => option.value == employee.employeeLeasingId || '')?.name || ''}
                            </EmployeeFormGroup>

                            <EmployeeFormGroup
                                    {editing}
                                    label="Grundlohnart"
                                    labelFor="basicWageType">
                                <svelte:fragment>
                                    <div class="w-auto flex justify-start items-center gap-4">
                                        <Label>
                                            <input
                                                    type="radio"
                                                    name="paymentMethod"
                                                    class="relative -top-0.5"
                                                    bind:value={employee.basicWageType}/>
                                            <span class="py-1">Stundenlohn</span>
                                        </Label>
                                        <Label>
                                            <input
                                                    type="radio"
                                                    name="paymentMethod"
                                                    class="relative -top-0.5"
                                                    bind:value={employee.basicWageType}/>
                                            <span class="py-1">Monatslohn</span>
                                        </Label>
                                    </div>
                                </svelte:fragment>
                                {employee.basicWageType || ''}
                            </EmployeeFormGroup>-->

            </svelte:fragment>

            <svelte:fragment slot="right">

                <EmployeeFormGroup
                        {editing}
                        label="Tätigkeit befristet bis"
                        labelFor="employmentLimitedAt"
                        type="date">
                    {dayjs(asValue(contract.endDate)).format('DD.MM.YYYY') || ''}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Sachgrund der Befristung"
                        labelFor="materialReasonForTheLimitation"
                        extract={selected => employee.materialReasonForTheLimitationId = selected.value}>
                    {contract.limitationReason || ''}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="á-conto-Zahlung"
                        labelFor="monthOfProbationaryPeriod"
                        suffix="€">
                    {contract.paymentOnAccount || ''} €
                </EmployeeFormGroup>
                <!--
                                        <EmployeeFormGroup
                                                {editing}
                                                label="Steuerbrutto"
                                                labelFor="taxBrutto"
                                                suffix="€">
                                            {#if employee.taxBrutto}
                                                {employee.taxBrutto || ''}
                                                €
                                            {/if}
                                        </EmployeeFormGroup>
                -->
                <EmployeeFormGroup
                        {editing}
                        label="Stunden pro Arbeitstag"
                        labelFor="hoursPerWorkingDay">
                    {contract.workHoursPerDay}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Arbeitstage pro Woche"
                        labelFor="workDaysPerWeek"
                        type="number">
                    {contract.workDaysPerWeek || ''}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Stunden pro Monat"
                        labelFor="hoursPerMonth">
                    {(contract.workHoursPerDay * contract.workDaysPerWeek * 4.3).toFixed(0)}
                </EmployeeFormGroup>

                <EmployeeFormGroup
                        {editing}
                        label="Jahresurlaub"
                        labelFor="annualLeave"
                        suffix="Tage">
                    {contract.ptoDays || ''} Tage
                </EmployeeFormGroup>
                <!--
                                        <EmployeeFormGroup
                                                {editing}
                                                label="Vertragsform"
                                                labelFor="formOfContract"
                                                data={formOfContractOptions}
                                                extract={selected => employee.formOfContractId = selected.value}>
                                            {formOfContractOptions.find(option => option.value == employee.religiousDenominationId || '')?.name || ''}
                                        </EmployeeFormGroup>

                                        <EmployeeFormGroup
                                                {editing}
                                                label="Lohnlauf"
                                                labelFor="wageRun"
                                                data={wageRunOptions}
                                                extract={selected => employee.wageRunId = selected.value}>
                                            {wageRunOptions.find(option => option.value == employee.religiousDenominationId || '')?.name || ''}
                                        </EmployeeFormGroup>

                                        <EmployeeFormGroup
                                                {editing}
                                                label="Austrittsdatum"
                                                labelFor="leavingDate">
                                            <svelte:fragment>{employee.leavingDate || ''}</svelte:fragment>
                                            {employee.leavingDate || ''}
                                        </EmployeeFormGroup>

                                        <EmployeeFormGroup
                                                {editing}
                                                label="Wochenarbeitszeit"
                                                labelFor="weeklyWorkingHours">
                                            <svelte:fragment
                                                   >{employee.weeklyWorkingHours || ''}</svelte:fragment>
                                            {employee.weeklyWorkingHours || ''}
                                        </EmployeeFormGroup>
                -->
            </svelte:fragment>

        </EmployeeWidget>
    </div>

{/each}